module.exports = __webpack_public_path__ + "img/peacebird.9b4d2eb6.png";